import React, { FC } from "react";

import { useTranslation } from "react-i18next";
import Box from "@mui/material/Box";

import { shouldBeHidden } from "../../../shouldBeHidden";
import { LabelValueProps } from "../LabelValue/LabelValue";
import { StyledLabelFeature, StyledLabelInfoFeature, StyledValueInfoFeature, StyledVerifiedShieldIcon } from "./styled";

export type FeatureItemProps = {
    key: string;
    label: string;
    infos?: LabelValueProps[];
};

const FeatureItem: FC<FeatureItemProps> = ({ label, infos = [] }) => {
    const { t } = useTranslation();
    const filteredInfos = infos.filter((item) => !shouldBeHidden(item));
    return (
        <Box display="flex" mt="5px">
            <StyledVerifiedShieldIcon />
            <Box flex={1} width="100%">
                <StyledLabelFeature>{label}</StyledLabelFeature>
                {filteredInfos.map((info) => (
                    <Box key={info.key} display="flex" gap={1} width="100%">
                        <StyledLabelInfoFeature>{t(info.label) || info.label}</StyledLabelInfoFeature>
                        <StyledValueInfoFeature>{t(info.value?.toString()) || "-"}</StyledValueInfoFeature>
                    </Box>
                ))}
            </Box>
        </Box>
    );
};

export default FeatureItem;
